import styled from "styled-components";

export const LoadingStyled = styled.div`
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0;
  right: 0;
  display: ${({ visible }) => (visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  /* ต้องอยู่เหนือ modal (z-index: 200) เหมือนเดิม
     ไม่งั้นจอโหลดจะโดน modal บัง ผู้ใช้ไม่รู้ว่าระบบกำลังทำงานอยู่ */
  z-index: 300;
  .yamaha_loading {
    width: 180px;
    height: auto;
  }
`;
